var exports = {
  "b": "LexicalChannelTextareaContent.module__composerHost___VW9fZH",
  "F": "LexicalChannelTextareaContent.module__composerEditable___VW9fZH",
};

module.exports = exports;
